/*
  An overview of how this javascript is meant to work as well as the files it interacts with can be found here:
  https://docs.google.com/document/d/1ua4KK9ES1Gfi1fFysqa0rk-YVsaIfaVJYVqAEALw80E
  I recommend starting there for a refresher on how it all works if it's been awhile
*/



$( document ).ready(function(){
  if(window.location.href.includes("/search?")){
    

    
    
    //set the number of results to show on each page
	var resultsPerPage = 48;
    
    
    

    
    //showStaticSearch() checks if user is set to use static search by checking the value of staticsearch in sessionStorage
    //it will also check if basic js functionality doesn't work in users browser (with a try catch)
    //and if it doesn't work it will result to true (not removing shopify static results and not adding dynamic results)
    if(showStaticSearch() == "false"){
      
      
        //I put all of this scripts functionality into a try catch statement, so that if there is a javascript error
        //whether it be the users browser doesn't support the javascript functionality we use, or possibly even a
        //problem fetching data from our data server the catch will be thrown and instead of nothing being shown on 
        //the page, the page will be set to show static results
      
      try { // statements to try
        main(resultsPerPage); //all script functionality
      }
      catch (e) {
        //if main throws any javascript errors, use static search
        activateStaticSearch();

      }
    

    } else {
      
      //only js used on this page should be the js that shows the message to allow the user to use dynamic search
      addUseDynamicSearchMessage();
    }
    

  }
  
});





function main(resultsPerPage){
  
   clearShopifyResults();

  //this can likely be removed later, it is used to convert any urls from the old search page 
  //(where everything is in the q url parameter) to the new style (then reload the page)
  //checks for _ in the q url parameter to decide if it's an old search url or not
  fixSearchesToOldSearchPage();


  //Show loading circle
  if($("#js-pulled-content").length > 0){
    var element = document.getElementById("js-pulled-content");
    element.innerHTML = '<div class="loader"></div>';
  }


  //header dropdown selecter always defaults back to Magazines
  fixHeaderCategorySelector();

  searchDatabase(resultsPerPage);

  createSidebar();


  //creates the pagination, also gets number of results
  createPagination(resultsPerPage);





}


  ///////////////////////////////////////////////////
 /////////////  Check If Logged In /////////////////
///////////////////////////////////////////////////
function checkIfLoggedIn(){
  
  var loggedIn = "false";
  
  var status = $(".header-log-button").first().attr("status");
  
  if(status == "logged in"){
    
    loggedIn = "true";
  
  }
  
  return loggedIn;

}






  //////////////////////////////////////////////////////////
 /////////////  Static Page (If JS Fails) /////////////////
//////////////////////////////////////////////////////////

/*
  These Functions are only used if for some reason our script fails to run 
  (most likely an outdated browser without the most recent version of JS)
*/


/*
  This function is used for deciding whether to show shopify static results or our JS dynamic results
  it does this by first checking to see if sessionstorage has staticsearch set to "true"
  or of this function fails to run, it means the user likely has a crappy browser or session storage
  turned off, so that will also set it to true
*/
function showStaticSearch(){
  
  var staticPage = "false";
  
  try {
    //these aren't actually used, it's included as a test, where if they don't work we want the catch to fire
    //(as browser doesn't support location.href or split()) and we want staticPage to be set to true 
    //so javascript doesn't remove static shopify results 
    var url = window.location.href.split('?')[0];
    var searchQuery = getArrayOfParamValuesByKey("q")[0];
  
    /////////////////////////////////////////////////////
    
  	var staticTempStorage = sessionStorage.getItem('staticsearch');

  
    if(staticTempStorage == "true"){
      staticPage = "true";
    }
  }
  
  catch (e) {
      staticPage = "true"; 
    //don't need to reload the page because static content won't be removed if it's set to true
  }

  
  return staticPage;

}



/*
  This is the function that runs if our javascript fails, it sets staticsearch to true in session storage
  adds some text to the page to let the use know dynamic results didn't load properly
  and then removes any js content that may have loaded before the script failed
*/
function activateStaticSearch(){
  sessionStorage.setItem('staticsearch', 'true');
  
   
  var noticeHtml = `
	<p class="text-center">
	Dynamic Results Failed to Load Properly<br>
	This Most Likely Means You're Using An Outdated Browser, We Recommend Using Chrome or Firefox<br>
	We've Disabled Dynamic Search, Try Your Search Again To See Results Without Sorting And Filtering<br>
	To Attempt To Enable Dynamic Results With Sorting And Filtering <span onclick="deactivateStaticSearch()" class="span-link">Click Here</span>
	</p>  
  `
  
  $("#js-notice").html(noticeHtml);


  
  var resultsHtml = `
	<p class="text-center">Try Your Search Again Or See:</p>
    <h3 class="text-center"><a href="/search?q=category_magazines">All Straight Magazines</a></h3>
    <h3 class="text-center"><a href="/search?q=category_gay-magazines">All Gay Magazines</a></h3>
    <h3 class="text-center"><a href="/search?q=category_dvds">All DVDs</a></h3>
  `
  
  $(".search-results-wrapper").html(resultsHtml);
  
  
  //clear any javascript results that may have been added to the page
  //note results can show up after this function runs (based on how long it takes for server to return results)
  //so this function is set to run every half second for 30 seconds
  for(var i = 1; i < 60; i++){
    var delayTime = i * 500;
    
    setTimeout(function() {
      $("#js-pulled-content").html( "" );
      $("#js-result-count").html( "" );
      $("#js-pagination").html( "" );
    }, delayTime);
    
  }
  

  
  
  
  
  
  
  /*
  //reload the page with only the search query entered
  //we had it work this way, but having the page reload every time it fails is an 
  //infinite refreshing loop risk if session storage doesn't work as expected
  
  var url = window.location.href.split('?')[0] + "?";
  
  var searchQuery = getArrayOfParamValuesByKey("q")[0];
  
  //if q= is in the url, set the search query for our new page to it, 
  if(searchQuery != undefined){
    url = url + "q=" + searchQuery;  
  }

  //go to the new page
  window.location.href = url;
  */
}


/*
  this is the only function that runs if staticresults is set to true in session storage
  
  it adds some text to the page to let the user know dynamic results are disabled,
  that they should upgrade their browser, and gives a link to click to try dynamic search again 
  in case it got turned off on a fluke error (the link removes staticresults from session storage 
  so it is no longer set to true)
*/
function addUseDynamicSearchMessage(){
  
  if($("#js-notice").length > 0){
    var element = document.getElementById("js-notice");
    element.innerHTML = `
      <p class="text-center">
        Dynamic Results Are Disabled<br>
        This Most Likely Means You're Using An Outdated Browser, We Recommend Using Chrome or Firefox<br>
        To Attempt To Enable Dynamic Results Including Sorting And Filtering <span onclick="deactivateStaticSearch()" class="span-link">Click Here</span>
	  </p>  
      `;
	}

}





/*
  This function is attached to links that are added to the page when static search is being used
  it is used to deactivate static search and reload the page, if there are no errors on reload
  dynamic search will stay activated, otherwise things will revert back to static search
*/
function deactivateStaticSearch(){
  // Remove saved data from sessionStorage
  sessionStorage.removeItem('staticsearch');
  location.reload();
}





  /////////////////////////////////////////////////////////
 ///////////////  clear shopify results  /////////////////
/////////////////////////////////////////////////////////

/*
  our search page is setup that a search will still be done to shopify's server in case the user doesn't have
  js enabled, they'll still be able to search products (just not filter or sort).
  
  This function removes the results returned by shopify, so we can show what's returned from our server instead.
*/
function clearShopifyResults(){
  //clear the standard search results from the page (results from shopify)
    if($(".search-results-wrapper").length > 0){
    	var element = document.getElementsByClassName("search-results-wrapper")[0];
    	element.innerHTML = "";
    }
  
   if($("#js-notice").length > 0){
    var element = document.getElementById("js-notice");
    element.innerHTML = '';
  }
}




  ///////////////////////////////////////////////////////////////
 /////  correct any urls that may be to old search page  ///////
///////////////////////////////////////////////////////////////

/*
  how it works:
  old search had everything for search and filtering + seperated in the "q" parameter in the url
  this function takes everything from that q parameter and splits it into an array using the + seperater

  it then goes through that array and creates a new url by pulling out the useful items in that array

  if there's no _ and the item isn't AND or OR (AND and OR were required for old search to function) then it's
  likely an actual search term that will be added to our new "q" parameter so we add it space seperated to "newQueryString"

  any time if finds a category_magazines or decade_90s it adds filter=category_magazines or filter=decade_90s
  to "newParameterArray" which that will be used to create a  new url.

  once we've pulled all the useful info from the old search url, we use it to construct a new url in the new style, 
  by taking everything from the "newParameterArray", adding our "newQueryString" (with a q= in front of it so it's now our query)
  sorting it, merging it together so it's & seperated ex. "filter=category_magazines&filter=decade_90s&q=hustler"
  then we just throw it at the end of our base url (https://www.discreetretail.com/search?) and navigate to the newly created url

*/
function fixSearchesToOldSearchPage(){
  
  //in old search everything was in the url q parameter (query/search parameter)
  var searchQuery = getArrayOfParamValuesByKey("q")[0];
  
  if(searchQuery != undefined){
  
    //if the search query contains an underscore, it is likely a link left over from old search page
    if (searchQuery.includes("_")){

      var newQueryString = "";
      var newParameterArray = [];

      //in old search everything was in the q parameter, plus seperated
      var searchQueryArray = searchQuery.split("+");

      for(var i = 0; i < searchQueryArray.length; i++){
        var currentQuery = searchQueryArray[i];

        //if current query item doesn't contain an _ isn't AND and isn't OR it should be an actual search item
        if(currentQuery.indexOf("_") === -1 && currentQuery != "AND" && currentQuery != "OR" ){
          newQueryString = newQueryString + " " + currentQuery;

        }


        if(currentQuery.includes("category_") || currentQuery.includes("decade_")){
          newParameterArray.push("filter=" + currentQuery);
        }

      }


      var queryParam = "q=" + newQueryString.trim();

      newParameterArray.push(queryParam);

      newParameterArray.sort();

      var newParameterString = newParameterArray.join("&");
      var rootUrl = window.location.href.split('?')[0];
      var fullUrl = rootUrl + "?" + newParameterString;

      //go to the new page
      window.location.href = fullUrl;

    }
  }


}





  ///////////////////////////////////////////////////////////////
 ///////////////  set header dropdown selector  ////////////////
///////////////////////////////////////////////////////////////

/*
  by default, the dropdown selecters returns to the first choice every time the page reloads
  This pulls the last used header dropdown from the url parameters and sets the 
  header dropdown (the one next to the search box in the header) to whatever it is in the url
*/

function getFirstParamFilterTagInCategory(tagCategory){
  
  var paramArray = getParamArray();
  var searchStr = "filter=" + tagCategory + "_"
  
  var tag = "";
  for(var i = 0; i < paramArray.length; i++){
    if (paramArray[i].includes(searchStr)){
      tag = paramArray[i].replace("filter=", "");
      return tag;
    }
    
  }
  
  return tag;
}


function fixHeaderCategorySelector(){
  
  //pull active category from the parameters
  var selectedCategoryTag = getFirstParamFilterTagInCategory("category");
  
  $("#header-category-selector").val(selectedCategoryTag).change();



}










/////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////
////////////////////// DATABASE SEARCH //////////////////////////////
/////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////

/*
  This is kind of the meat and potatoes of the whole operation
  it constructs the url that will be sent to our database 
  ex:
  https://great-offer.org/discreetretail/getproducts.php?filters=category_magazines&search=hustler&sort=newest-oldest&limit=48&page=1
  
  then sends it
  
  resultsPerPage: this is set to the number of results to return on each page, 
  I put this variable at the top so it can easily be modified in the future

*/



function searchDatabase(resultsPerPage){
   	
    var requestUrl = getRequestUrl();
    var pageNumber = getPageNumber();
  
    
  
    requestUrl = requestUrl + "&limit=" + resultsPerPage + "&page=" + pageNumber;
  
    
    $.get(requestUrl, function(data, status){
      
      console.log("requesting:" + requestUrl);
      
	  manageData(data);
      
      
    });



}



function getRequestUrl(){
  
  var search = pullSearchQuery();
  var sidebarFilters = pullSidebarFilterStringFromParams();
  var priceFilters = pullPriceFiltersFromParams();
  var sort = pullSortFromParams();
  
  var loggedStatus = checkIfLoggedIn();
  
  //remove adult results when logged in too
  //loggedStatus = "false";
  

  var requestUrl = "https://great-offer.org/discreetretail/getproducts2.php?";
  
  requestUrl = requestUrl + "filters=" + sidebarFilters + "&search=" + search + priceFilters + sort + "&logged="  + loggedStatus;

  return requestUrl;



}

function pullSearchQuery(){
 
  var searchQuery = getArrayOfParamValuesByKey("q")[0];
  
  if(searchQuery == undefined){
  	searchQuery = ""; 	
  }
  
  return searchQuery;



}


//shuold return "+" seperated tags in tagCategory_tag format
//ex. decade_50s+decade_60s+condition_preowned
function pullSidebarFilterStringFromParams(){

  //get all parameters from as an array
  var paramArray = getParamArray();
  
  //loop through the parameter array, if the parameters key = filter, it's a sidebar filter, add it to the string
  var sidebarFiltersStr = "";
  for(var i = 0; i < paramArray.length; i++){
    var key = paramArray[i].split("=")[0];
    var value = paramArray[i].split("=")[1];

    //if the key is filter, we're working with a sidebar filter
    if(key.includes("filter")){
      
      sidebarFiltersStr = sidebarFiltersStr + " " + value;      
    }   
  }
  
  //+ and " " seem to be interpreted the same on php server, I like + better so it doesn't get replaced with %20
  sidebarFiltersStr = sidebarFiltersStr.trim().replaceAll(" ", "+")

  return sidebarFiltersStr;


}


function pullPriceFiltersFromParams(){

  var maxPrice = getArrayOfParamValuesByKey("pricemax")[0];
  var minPrice = getArrayOfParamValuesByKey("pricemin")[0];
  
  var minPriceParam = "";
  if(minPrice != undefined){
  	minPriceParam = "&pricemin=" + minPrice; 	
  }
  
  var maxPriceParam = "";
  if(maxPrice != undefined){
    maxPriceParam = "&pricemax=" + maxPrice;
  }
  
  return minPriceParam + maxPriceParam;
  


}

function pullSortFromParams(){
  
  var sortValue = getArrayOfParamValuesByKey("sort")[0];
  
  var sortParam = "";
  if(sortValue != undefined){
    sortParam = "&sort=" + sortValue;
  }

  return sortParam;


}





function manageData(data){

  
  jsonData = JSON.parse(data);
  
  //console.log("parsed json data");
  //console.log(jsonData);
  
  
  //remove loading text result element
  var element = document.getElementById('js-pulled-content');
  element.innerHTML = "";
  
  
  if(jsonData.length > 0){
    jsonData.forEach(function(product, index) {
      //note I could look into snagging some tracking data 
      //in the product link and sending it to a database table
      addContentToPage(product, index);
    });
  }else{
  	addNoResultsFoundContent();
  
  }
  

}


/*
product = json for the current product
index = what number product we're on, could be used for tracking which item a customer clicks on, 
would have to add a page multiplier otherwise it makes the first item on each page rank 1
*/
function addContentToPage(product, index){
  //index starts at zero, adding this so if later I want to try to track how far someone went before clicking on an item I can
  var rank = index + 1;
  var handle = product.handle;
  var price = product.price;
  var comparePrice = product.compare_price;
  var imgSrc = product.image_src;
  var condition = product.product_condition;
  //grab smaller version of the image to reduce loading time
  imgSrc = imgSrc.replace(".jpg", "_300x.jpg");
  var title = product.title;
  
  var tags = product.tags;
  
  if(condition == null){
  	condition = "";
  }
  
  //if not logged in
  if(checkIfLoggedIn() == "false"){
    
    //make title just the first section of the title to avoid any words advertisers might not like

    var skuCat = product.sku.split("-")[0].trim().toLowerCase();
    
    var productType = "";
    
    if(skuCat == "am" || skuCat == "aml" ){productType = "Vintage Adult Magazine"}
    if(skuCat == "amn"){productType = "New Adult Magazine"}
    if(skuCat == "amg" ){productType = "Gay Interest Adult Magazine"}
    
      
    title = title.split("-")[0].trim() + " - " + productType;
    
    
    //if not logged in and there's no SafeImages:Cover and no SafeImages:All tag
    if(tags.toLowerCase().indexOf("safeimages:cover") == -1 && tags.toLowerCase().indexOf("safeimages:all") == -1 ){
      //imgSrc = "https://cdn.shopify.com/s/files/1/1390/2327/files/CreateAnAccount.png?v=1643084324";
    }

  }
  
  
  
  var productPriceHtml = `
  <span class="product-price">$${price}</span>
  <span class="visually-hidden">$${price}</span>

`
  //if products compare price is greater than the sale price (product is on sale) show sale price and percentage off
  if (parseInt(comparePrice) > parseInt(price)){
    var savePercent = 100 - Math.round((price / comparePrice) * 100); 
    var productPriceHtml = `
    <span class="sale-product-price">$${price}</span>
    <span class="visually-hidden">$${price}</span>
    <span class="sale-product-old-price"><s>Originally $${comparePrice}</s></span>
    <span class="sale-product-percent-saved">Save ${savePercent}%</span>

`
    }
  
  var productHtml = `
<div class="rows-search-result-wrapper">
    <div class="rows-search-result-image-wrapper">
<a href="/products/${handle}?_pos=${rank}" class="search-result-link">
        <img class="rows-search-result-image" src="${imgSrc}" alt="${title}">
    </a>
    </div>
    <div class="rows-search-result-info-wrapper">
        <a href="/products/${handle}?_pos=${rank}" class="search-result-link">
        <span class="rows-search-result-title">${title}</span>
        </a>
        <div class="rows-search-result-condition">${condition}</div>   
        <div class="rows-search-result-price">     

            ${productPriceHtml}
            
        </div>
    </div>
</div>`;


	var element = document.getElementById('js-pulled-content');
    element.innerHTML += productHtml;


}



function addNoResultsFoundContent(){
  
  var noResultsHtml = "";
  
  //if logged in
  if(checkIfLoggedIn() == "true"){
    
    noResultsHtml = `
    <h2>No Results</h2>
	`;
    
    
  //if not logged in  
  }else{
    
    noResultsHtml = `
    <h2 class="text-center">No Results</h2>
	<p class="text-center"><a href="/account/register">Create a Free Account</a> or <a href="/account/login">Log In</a> to See More</p>
    
	`;
  
  }
  
  
  var element = document.getElementById('js-pulled-content');
  element.innerHTML = noResultsHtml;



}














/////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////
////////////////////// CREATE SIDEBAR ///////////////////////////////
/////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////






var sidebarJSON = {
    "categories": [
        {
            "title": "Magazines",
        	"tag": "Category_Magazines",
            "login": "false",
            "subCategories": [
                {
                    "title": "Condition",
                    "tagCategories": [
                        "New",
                        "Preowned"
                    ]
                },
                {
                    "title": "Decade",
                    "tagCategories": [
                        "2k",
                        "90s",
                        "80s",
                        "70s",
                        "60s",
                        "50s",
                        "Unknown"
                    ]
                }
            ]
        },
        {
            "title": "TV Magazines",
            "tag": "Category_TV-Magazines",
            "login": "true",
            "subCategories": []
        },
        {
            "title": "Gay Magazines",
            "tag": "Category_Gay-Magazines",
            "login": "false",
            "subCategories": [
                {
                    "title": "Condition",
                    "tagCategories": [
                        "New",
                        "Preowned"
                    ]
                },
                {
                    "title": "Decade",
                    "tagCategories": [
                        "2k",
                        "90s",
                        "80s",
                        "70s",
                        "60s",
                        "50s",
                        "Unknown"
                        
                    ]
                }
            ]
        },
        {
            "title": "DVDs",
            "tag": "Category_DVDs",
            "login": "true",
            "subCategories": []
        }
    ]
}





function createSidebar(){ 
  

  
  addSortToSidebar();
  
  
  
  //add the "Categories" HTML to the sidebar along with the different categories
  //ex. magazines, DVDs etc
  addTopCategoriesToSidebar();
  
  //remove any sidebar categories that might currently be active
  var sidebarContainer = document.getElementById('js-sidebar-sub');
  sidebarContainer.innerHTML = "";
  
  addPriceBoxesToSidebar();
              
  activateActiveSidebarCategory();
  
  setSidebarLinks();
  
  checkActiveSidebarBoxes();
  
  fillInActivePriceFilters();
  
  //not sure why buy putting this right under addSortToSidebar() made it not work
  //looks like there may be an issue with running some js functions while html is still being added to the page
  setSortValue();
  
  
}


/*
  add sort dropdown menu to sidebar
  note the value="" is what will end up being sent to the server
  the getproducts.php script is looking for these exact values to know the sort to add to the sql statement
*/
function addSortToSidebar(){
  
  var sortHtml = `
  <h2 class="search-group-header">Sort</h2>

  <select name="sort" id="sort" onchange="sortChange(value)">
	  <option value="featured">Featured</option>
      <option value="newest-oldest">Newly Listed</option>
      <option value="oldest-newest">Oldest Listed</option>
      <option value="price-low-high">Price: Low to High</option>
      <option value="price-high-low">Price: High to Low</option>
      <option value="alphabetically">Alphabetically</option>
  </select>
  `

  var sidebarContainer = document.getElementById('js-sidebar');
  sidebarContainer.innerHTML += sortHtml;
  
  
  
  

}


/*
  this function is needed because by default, dropdown menus are set to their first value on page reload
  this function pulls the last used sort value from the url and sets our sidebar dropdown menu to that value
*/

function setSortValue(){
  
  //pull sort parameter from url
  var activeSortParam = getArrayOfParamValuesByKey("sort")[0];
  
  //if a sort param exists in the url, set the sort dropdown to display that value
  if(activeSortParam != undefined){

    $("#sort").val(activeSortParam).change();
    
  }
  

}

/*

  This function is attached to our sidebar dropdown and is run every time the sidebar dropdown is changed
  it is used to set the sort= parameter in the url
  
  sortValue: this is set to the value="" of whichever dropdown item is selected, ex. price-low-high

  this function is a bit sketchy combined with setSetSortValue() as this function 
  runs any time the sort drop down value is changed and causes the page to load (meant to happen when the user changes it)
  and that function changes the drop down value every time the page is loaded (because it always resets to the first option by default)
  there are if statements to prevent an infinite reloading loop, but I'm not certain they're enough
  I could prevent any concern by instead reloading the page when a go button is clicked or something like that
 
*/
function sortChange(sortValue){
  
  
  if(getArrayOfParamValuesByKey("sort")[0] != sortValue){
    
    var paramArray = getParamArray();
  
    //on param change go back to page 1 so remove the page param from the array
    paramArray = removeAllStringsContainingFromArray(paramArray, "page=");
    //remove preexisting sort param if it exists
    paramArray = removeAllStringsContainingFromArray(paramArray, "sort=");

    paramArray.push("sort=" + sortValue);

    paramArray.sort();

    var paramString = paramArray.join("&");
    var rootUrl = window.location.href.split('?')[0];

    var fullUrl = rootUrl + "?" + paramString;


    //go to the new page
    window.location.href = fullUrl;
  
  }
  
  
  
}



/*
  Adds the "Categories" section to the sidebar
  These are pulled from our sidebarJSON above
*/
function addTopCategoriesToSidebar(){
  
  var loggedIn = checkIfLoggedIn();
  
  //used to not show dvds and tv magazines categoried in sidebar when logged in
  //loggedIn = "false";
  
  var htmlTop = `
  <div class="sidebar-tag-group-container">
      <h2 class="search-group-header">Category</h2>
      <ul class="my-advanced-filters sidebar-unordered-list">

  `;
  
  var htmlCenter = "";

  for(var i = 0; i < sidebarJSON.categories.length; i++){
    
    var currentCategoryJson = sidebarJSON.categories[i];
    
    var requiresLogin = currentCategoryJson.login;
    
    //if logged in show all content, 
    //Or if loggedIn wasn't true, check if this sidebar category requires login, if it doesn't, show it
    if (loggedIn == "true" || requiresLogin == "false"){
    
      var categoryTitle = currentCategoryJson.title;
      var categoryTag = currentCategoryJson.tag.toLowerCase();

      var currentHtml = `
      <li class="sidebar-list-item my-advanced-filter" data-group="Category" data-handle="${categoryTag}">
        <a href="" class="category-link">
          <div class="sidebar-item-wrapper">
            <div class="sidebar-checkbox checkbox" data-group="Category" data="${categoryTitle}" data-handle="${categoryTag}"></div>
            <div class="checkbox-tag-wrapper">${categoryTitle}</div>
          </div>
        </a>
      </li>
      `;

      htmlCenter = htmlCenter + currentHtml;
    }
   
  }

  var htmlBottom = `
      </ul>
  </div>
  <span id="js-sidebar-sub">
  </span>
  `;
  
  var fullHtml = htmlTop + htmlCenter + htmlBottom;
  
  
  var sidebarContainer = document.getElementById('js-sidebar');
  sidebarContainer.innerHTML += fullHtml;
  
}


/*
  Adds the price boxes html to the sidebar
*/
function addPriceBoxesToSidebar(){

  var currentHtml = `
	<h2 class="search-group-header">Price</h2>

		<span class="price-box">
          <label for="min-price">Min:</label>
<input type="number" id="min-price" class="sidebar-price-box" placeholder="$: Min" name="min-price">
		</span>

		<span class="price-box">
          <label for="max-price">Max:</label>
<input type="number" id="max-price" class="sidebar-price-box" placeholder="$: Max" name="max-price">
		</span>

		<button id="sidebar-price-btn" type="button" onclick="priceButtonClick()">Go</button>

	`;
  

  
  var sidebarContainer = document.getElementById('js-sidebar-sub');
  sidebarContainer.innerHTML += currentHtml;

}


/*
  This function is attached to the "Go" Button on our price section in the sidebar
  
  it pulls the values entered in the boxes, parses them as integers creates a url then goes to that page
  (the page loading will cause the get request to our server with these added parameters to be called)
*/
function priceButtonClick(){

  var maxPrice =  parseInt($("#max-price").val());
  var minPrice =  parseInt($("#min-price").val());
  
  //if user enters min price and max price backwords, swap em
  if(minPrice > maxPrice){
    maxPrice = minPrice;
    minPrice = maxPrice;
  }
  
  
  ////////create the link////////////
  
  var paramArray = getParamArray();
  //We want to be back on page 1 every time the price is changed so remove page number parameter
  paramArray = removeAllStringsContainingFromArray(paramArray, "page=");
  //remove any preexisting min or max price
  paramArray = removeAllStringsContainingFromArray(paramArray, "pricemin=");
  paramArray = removeAllStringsContainingFromArray(paramArray, "pricemax=");

  if (minPrice > 0){
    var minPriceParam = "pricemin=" + minPrice; 
    paramArray.push(minPriceParam);
  }
  
  if (maxPrice > 0){
    var maxPriceParam = "pricemax=" + maxPrice; 
    paramArray.push(maxPriceParam);
  }

  paramArray.sort();
  
  var paramString = paramArray.join("&");
  var rootUrl = window.location.href.split('?')[0];
  
  var fullUrl = rootUrl + "?" + paramString;
  
  
  //go to the new page
  window.location.href = fullUrl;
  

}



/*
  the goal of this function is to figure out which top level category (magazines, dvds, etc) is active
  using the parameters in the url, it looks for filter=category_ , once found, 
  add all of that categories subcategories to the sidebar using activateSidebarCategory(categoryName)
*/
function activateActiveSidebarCategory(){
  var paramArray = getParamArray();
  
  for(var i = 0; i < paramArray.length; i++){
    
    if(paramArray[i].toLowerCase().includes("filter=category_")){
      var categoryName = paramArray[i].replace("filter=category_","");
      
      // activateSidebarCategory(categoryName) wants categoryName in human readable form, ex gay magazines, not gay-magazines
      categoryName = categoryName.replace("-", " ")
      
      activateSidebarCategory(categoryName);
      
      //we've done what we need to do no need to keep looping through params exit this function
      return
    
    } 
  }
}



/*
  the goal of this function is to pull sub category data from the sidebar json using the subcategories name
  ex. magazines, gay magazines etc.

  categoryName: requires a category 

*/
function activateSidebarCategory(categoryName){
  
  
  //the json title is a human readable title, so just in case a - snuck into the category name, replace it with a space
  categoryName = categoryName.replace("-", " ");
  
  //get the current categories json based on the categories title
  var currentCategoryJson = "";
  for(var i = 0; i < sidebarJSON.categories.length; i++){
    if(sidebarJSON.categories[i].title.toLowerCase() == categoryName.toLowerCase()){
      currentCategoryJson = sidebarJSON.categories[i]; 
    }
  }
  
  
  
  
  //for each subcategory this category has (decade, condition etc) add it to the sidebar
  for(var i = 0; i < currentCategoryJson.subCategories.length; i++){  
    var currentSubCategoy = currentCategoryJson.subCategories[i];
    addSubCategoryToSidebar(currentSubCategoy);

  }

  
}



/*
  create the html for a sidebar subcategory, ex. Decade
  (including its tagCategories, 80s, 90s etc.) and adding it to the sidebar
  
  categoryJson: this contains all the JSON for this particular Sub Category, ex. all the JSON for Decade
*/

function addSubCategoryToSidebar(categoryJson){
  var categoryTitle = categoryJson.title;
  
  var htmlTop = `
    <h2 class="search-group-header">${categoryTitle}</h2>
      <ul class="my-advanced-filters sidebar-unordered-list">
  `;
  
  var htmlCenter = "";

  for(var i = 0; i < categoryJson.tagCategories.length; i++){
    
    var currentData = categoryJson.tagCategories[i];  
    var currentTag = categoryTitle + "_" + currentData;  
    currentTag = currentTag.toLowerCase();
    var currentHtml = `
	<li class="sidebar-list-item my-advanced-filter" data-group="${categoryTitle}" data-handle="${currentTag}">
	<a href="" class="sub-category-link">
      <div class="sidebar-item-wrapper">
        <div class="sidebar-checkbox checkbox" data-group="${categoryTitle}" data="${currentData}" data-handle="${currentTag}"></div>
        <div class="checkbox-tag-wrapper">${currentData}</div>
      </div>
    </a>
	</li>
	`;
    
    htmlCenter = htmlCenter + currentHtml;
   
  }
  
  
  var htmlBottom = `
    </ul>
  `;
  
  var fullHtml = htmlTop + htmlCenter + htmlBottom;
  
  
  var sidebarContainer = document.getElementById('js-sidebar-sub');
  sidebarContainer.innerHTML += fullHtml;


}






//by default sidebar links don't do anything, this replaces their ahrefs with that they should be
function setSidebarLinks(){
  
  //if the sidebar link has the class category-link it is in the top level category ex(magazines, dvds)
  //if a different category is clicked, we want to switch categories
  $(".category-link").each(function( index ) {   
    var tag = $(this).parent().attr("data-handle").toLowerCase();
    var href = createExclusiveSidebarLink(tag);
    $(this).attr("href", href);
  });
  
  //if the sidebar link has the class sub-category-link it is a subcategory link ex(80s, 90s, new)
  //if a different category is clicked, we want to keep all
  $(".sub-category-link").each(function( index ) {   
    var tag = $(this).parent().attr("data-handle").toLowerCase();
    var href = createInclusiveSidebarLink(tag);
    $(this).attr("href", href);
  });
  




}

//used for creating sidebar links that when clicked, disable all other sidebar filters,
//used for category filters, ex magazines, dvds, where filters from 1 category might not apply to another
function createExclusiveSidebarLink(tag){
  var paramArray = getParamArray();
  var tagParam = "filter=" + tag.toLowerCase();
  
  if(paramArray.includes(tagParam)){   

    //clicking the already active filter will currently refresh the page as I don't currently want no category filters selected
    return window.location.href;
    
  }else{   

    //remove all active filters as new category may not have same filters
    var newParamArray = removeAllStringsContainingFromArray(paramArray, "filter=");
    
    //We also want to be back on page 1 every time the filter is changed so remove page number parameter
    newParamArray = removeAllStringsContainingFromArray(paramArray, "page=");

    //now that every filter has been removed add the filter for this category
    newParamArray.push("filter="+tag);
    newParamArray.sort();

    var newParamString = newParamArray.join("&");
    var rootUrl = window.location.href.split('?')[0];

    return rootUrl + "?" + newParamString;
  }


}



//create a sidebar link that keeps all other sidebar filters
function createInclusiveSidebarLink(tag){
  var paramArray = getParamArray();
  //We want to be back on page 1 every time the filter is changed so remove page number parameter
  paramArray = removeAllStringsContainingFromArray(paramArray, "page=");
  
  
  
  var tagParam = "filter=" + tag.toLowerCase();
  
  //if this tag is already active (already in the param array), deactivate it (remove from param array)
  if(paramArray.includes(tagParam)){   
    paramArray = removeItemFromArray(paramArray, tagParam);    
  }else{   
    paramArray.push(tagParam);
  }
  
  
  paramArray.sort();
  
  var paramString = paramArray.join("&");
  var rootUrl = window.location.href.split('?')[0];
  
  return rootUrl + "?" + paramString;


}




//use url parameters to see which filters are active, make any sidebar items that are, appear to be "checked"
function checkActiveSidebarBoxes(){
  
  var paramArray = getParamArray();
  
  for(var i = 0; i < paramArray.length; i++){
    
    if(paramArray[i].toLowerCase().includes("filter=")){
      var tag = paramArray[i].replace("filter=","");
      
      var checkboxSelector = ".sidebar-checkbox[data-handle='" + tag + "']"
      $(checkboxSelector).addClass("checked");

    
    } 
  }
  

}


//use url parameters to see which price filters are active, and fill in the price filter if any are active
function fillInActivePriceFilters(){

  var minPrice = getArrayOfParamValuesByKey("pricemin")[0];
  var maxPrice = getArrayOfParamValuesByKey("pricemax")[0];
  
  minPrice = parseInt(minPrice);
  maxPrice = parseInt(maxPrice);
  

  if(minPrice > 0){
  	$("#min-price").val(minPrice);
  }

  if(maxPrice > 0){
    $("#max-price").val(maxPrice);
  }

}












/////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////
///////////////////// CREATE PAGINATION /////////////////////////////
/////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////




function createPagination(resultsPerPage){
  
  var baseRequestUrl = getRequestUrl();
  var countRequestUrl = baseRequestUrl + "&count=true";
  
  console.log(countRequestUrl);
  
  $.get(countRequestUrl, function(data, status){
    
    var resultCount = data;
    
    var loggedIn = checkIfLoggedIn();
    if (loggedIn == "true"){
      var resultCountHtml = "<p>Results: " + resultCount + "</p>";
      $("#js-result-count").html(resultCountHtml);
    
    }
    
    
    
    addPaginationToPage(resultsPerPage, resultCount);
    
    



  });




}

function addPaginationToPage(resultsPerPage, resultCount){
  
  //clear our current pagination if it exists on the page
  if($('.pagination-custom').length > 0){
  	var element = document.getElementsByClassName("pagination-custom")[0];
  	element.innerHTML = "";
  }
  
  //last page = number of results divided by results per page, rounded up
  var lastPage = Math.ceil(resultCount / resultsPerPage);
  var pageNumber = getPageNumber();
  
  
  
  var pageUrl = window.location.href;
  
  if (pageUrl.includes("page=")){
    //pageurl has the page parameter we need 
  }else{
    //upcoming code works by replacing page= parameter in the url so we need to make sure it's in there
    //the only way it wouldn't be in the url already is if we were on the first page
  	pageUrl = pageUrl + "&page=1";
    pageNumber = 1;
  }
  
  
  
  var pageParam = "page=" + pageNumber;
  
  
  var previousPageParam =  "page=" + (pageNumber - 1);
  var previousPage2Param =  "page=" + (pageNumber - 2);
  var nextPageParam = "page=" + (pageNumber + 1);
  var nextPage2Param = "page=" + (pageNumber + 2);
  
  var lastPageParam = "page=" + lastPage;
  
  
  
      
  var previousPageUrl = pageUrl.replace(pageParam, previousPageParam);
  var previousPage2Url = pageUrl.replace(pageParam, previousPage2Param);
  var nextPageUrl = pageUrl.replace(pageParam, nextPageParam);
  var nextPage2Url = pageUrl.replace(pageParam, nextPage2Param);
  
  var firstPageUrl = pageUrl.replace(pageParam, "page=1");
  var lastPageUrl = pageUrl.replace(pageParam, lastPageParam);
  
  

  
  
  
  
  var previousPageHtml = '<li class="disabled"><span>←</span></li>';
  if(pageNumber > 1){
    previousPageHtml = `<li><a href="${previousPageUrl}" title="« Previous">←</a></li>`;
  }
  
  var nextPageHtml = '<li class="disabled"><span>→</span></li>';
  if(pageNumber < lastPage){
    nextPageHtml = `<li><a href="${nextPageUrl}" title="Next »">→</a></li>`;
  }
  
  
  var firstPageHtml = "";
  if(pageNumber > 3){
    firstPageHtml = `<li><a href="${firstPageUrl}" title="">1</a></li>`;
  }
  

  var lastPageHtml = "";
  //don't show last page link unless there are more than 3 pages
  if(lastPage > 3){
    
    if(pageNumber < lastPage){
    	lastPageHtml = `<li><a href="${lastPageUrl}" title="">${lastPage}</a></li>`;
    }
  
  }
  
  
  
  
  
  var numPreviousPageHtml = "";
  if(pageNumber > 1){
    numPreviousPageHtml = `<li><a href="${previousPageUrl}" title="">${pageNumber - 1}</a></li>`;
  }
  
  var numPrevious2PageHtml = "";
  if(pageNumber > 2){
    numPrevious2PageHtml = `<li><a href="${previousPage2Url}" title="">${pageNumber - 2}</a></li>`;
  }
  
  var numPreviousGapHtml = "";
  if(pageNumber > 4){
    numPreviousGapHtml = "<li><span>…</span></li>";
  }
  
  var currentPageHtml = `<li class="active"><span>${pageNumber}</span></li>`;
  
  
  var numNextPageHtml = "";
  if(pageNumber < lastPage){
    numNextPageHtml = `<li><a href="${nextPageUrl}" title="">${pageNumber + 1}</a></li>`;
  }
  
  var numNextPage2Html = "";
  if(pageNumber < lastPage - 1){
    numNextPage2Html = `<li><a href="${nextPage2Url}" title="">${pageNumber + 2}</a></li>`;
  }
  
  var numNextGapHtml = "";
  if(pageNumber < lastPage - 2){
    numNextGapHtml = "<li><span>…</span></li>";
  }
  
  
  
  
  
  var paginationHtml = '<ul class="pagination-custom">' + previousPageHtml + firstPageHtml + numPreviousGapHtml + numPrevious2PageHtml + numPreviousPageHtml + 
  currentPageHtml + numNextPageHtml /*+ numNextPage2Html*/ + numNextGapHtml + lastPageHtml + nextPageHtml + '</ul>';
  
  
  //if theres more than 1 page and js-pagination exists
  if(lastPage > 1 && $("#js-pagination").length > 0){
    document.getElementById("js-pagination").innerHTML = paginationHtml;
  
  }
  



}








/////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////
///////////////////// HELPER FUNCTIONS //////////////////////////////
/////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////



//returns parameters as a sorted array
function getParamArray(){
  var urlParams = window.location.search;
  //remove the leading ? at the start of the param string
  urlParams = urlParams.replace("?", "");
  var paramArray = urlParams.split('&').sort();
  return paramArray;
}



//returns all url parameters with a certain key as an array
function getArrayOfParamValuesByKey(key){
  var fullParamArray = getParamArray();
  
  var fullKey = key + "=";
  
  var valueArray = [];
  var value = "";
  for(var i = 0; i < fullParamArray.length; i++){
    if(fullParamArray[i].includes(fullKey)){
      value = fullParamArray[i].replace(fullKey, "");
      valueArray.push(value);
    
    }       
  }
  
  return valueArray;

}




//remove an item from an array
function removeItemFromArray(arr, item) {
  var index = arr.indexOf(item);
  if (index > -1) {
    arr.splice(index, 1);
  }
  return arr;
}

//remove all items from an array that contain value
function removeAllStringsContainingFromArray(array, value) {
  var i = 0;
  while (i < array.length) {
    if (array[i].includes(value)) {
      array.splice(i, 1);
    } else {
      ++i;
    }
  }
  return array;
}






////////// other helpful functions /////////////

function getPageNumber(){
  
  var urlParams = getParamArray();
  //if no page= is found in url, we're on page 1
  var currentPage = 1;
  
  for (var i = 0; i < urlParams.length; i++){
    if(urlParams[i].includes("page=")){
      //remove page= from the parameter to get just the page number
      var currentPageStr = urlParams[i].replace("page=", "");
      //make sure the page number is an integer
      currentPage = parseInt(currentPageStr);
    } 
  }
  
  return currentPage;
}




















//////////////////////////Graveyard//////////////////////////////

//uses functionality that isn't compatible with older browsers and internet explorer, consider trying a different way
/*
function getURLParameters(){
  var urlParameters = new URLSearchParams(window.location.search);
  var params = Object.fromEntries(urlParameters.entries()); 
  return params;
}
*/




/*
function activateCategoryIfNoneActive(defaultCategory){
  //if no category is selected, select the default category in the sidebar
  if($(".checked").length == 0){
    //find the checkbox for the sidebar category and select it
    var checkboxSelector = ".sidebar-checkbox[data='" + defaultCategory + "']"
    $(checkboxSelector).addClass("checked");
    //add all of the category's subcategories to the sidebar
  	activateSidebarCategory(defaultCategory);
  }


}

*/

/*
function addSidebarCategoryClickEvents(){
    //if in the category sidebar group, ex magazines, dvds
  $(".sidebar-tag-group-container").find(".sidebar-list-item").on('click', function(event){
    //only 1 category group should be selected, so remove all checked boxes in the category group
    $(".sidebar-tag-group-container").find(".sidebar-checkbox").removeClass("checked");
    //then check the one that was selected
    $(this).find(".sidebar-checkbox").addClass("checked");
    
    //figure out what the name of the category selected is
    var selectedCategory = $(this).find(".sidebar-checkbox").attr("data");
    //and activate that category (add appropriate subcategories to sidebar and add click events to them)
    activateSidebarCategory(selectedCategory);
    
    searchDatabase();
    
  
  
  });




}

*/


/*
function addSidebarSubCategoryClickEvents(){

  
  $("#js-sidebar-sub").find(".sidebar-list-item").on('click', function(event){
    //event.stopPropagation();
    //event.stopImmediatePropagation();
  
    console.log("sidebar item was clicked");

    var $sidebarCheckbox = $(this).find(".sidebar-checkbox");

    //if element is checked
    if($sidebarCheckbox.hasClass("checked")){  
      //remove checked class 
      $sidebarCheckbox.removeClass("checked");
    }else{
      //add checked class
      $sidebarCheckbox.addClass("checked");
    }

    //make this element checked or unchecked
    //run a get request with all checked items and search
    searchDatabase();

  });


}

*/


/*
function pullSidebarFilters(){
  var $checkedSidebarItems = $(".checked");
  
  var sidebarFilters = "filters=";
  
  $checkedSidebarItems.each(function() {
  	var data = $( this ).attr( "data" );
    //tags in database seem to have dashes instead of spaces
    //data = data.replaceAll(" ", "-");
    var dataGroup = $( this ).attr( "data-group" );
    sidebarFilters = sidebarFilters + " " + dataGroup + "_" + data
  });
  
  console.log(sidebarFilters);
  
  return sidebarFilters;

}
*/



/*
//used for creating sidebar links that when clicked, disable all other sidebar items in their category
function createExclusiveSidebarLink(tag){
  var paramArray = getParamArray();
  
  var tagCategory = tag.split("_")[0];
  var tagItem = tag.split("_")[1];
  
  //the following will remove any parameters that contain the category in the text, 
  //add back filter= and the underscore to prevent false positives
  tagCategory = "filter=" + tagCategory + "_";
  var newParamArray = removeAllStringsContainingFromArray(paramArray, tagCategory);
  
  //now that every tag from this category has been removed, add back this item
  newParamArray.push("filter="+tag);
  newParamArray.sort();
  
  var newParamString = newParamArray.join("&");
  var rootUrl = window.location.href.split('?')[0];
  
  return rootUrl + newParamString;


}

*/


/*


function setURLParameters(key, value){
  
  var urlParams = new URLSearchParams(window.location.search);
  
  urlParams.set(key, value);


  window.location.search = urlParams;


}


*/